import Plugin from "@ckeditor/ckeditor5-core/src/plugin"

//
// imgにloading属性を追加する
// model -> viewへの変換の時のみloading属性を追加している
// 処理については以下を参考に実装した
// https://ckeditor.com/docs/ckeditor5/latest/framework/guides/deep-dive/conversion/conversion-preserving-custom-content.html#adding-extra-attributes-to-elements-contained-in-a-figure
//
export default class AddLazyLoadingToAllImages extends Plugin {
  afterInit() {
    const editor = this.editor

    editor.conversion.for("downcast").add((dispatcher) => {
      dispatcher.on("insert:image", (evt, data, conversionApi) => {
        const modelElement = data.item
        const viewFigure = conversionApi.mapper.toViewElement(modelElement)
        const viewElement = this.findViewChild(viewFigure, "img", conversionApi)
        if (!viewElement) {
          return
        }
        conversionApi.writer.setAttribute("loading", "lazy", viewElement)
      })
    })
  }

  /**
   * Helper method that searches for a given view element in all children of the model element.
   *
   * @param {module:engine/view/item~Item} viewElement
   * @param {String} viewElementName
   * @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
   * @return {module:engine/view/item~Item}
   */
  findViewChild(viewElement, viewElementName, conversionApi) {
    const viewChildren = Array.from(
      conversionApi.writer.createRangeIn(viewElement).getItems()
    )

    return viewChildren.find((item) => item.is("element", viewElementName))
  }
}
